module.exports = __webpack_public_path__ + "newprotal/img/adv-02.4f140774.jpg";